import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import Lottie from 'lottie-react';
import lottie401 from 'assets/img/animated-icons/locked.json';

const Error401 = () => {
  return (
    <Card className="text-center">
      <Card.Body className="p-5">
        <center>
          <div className="display-1 text-300 fs-error w-75">
            <Lottie animationData={lottie401} loop={true} />
          </div>
        </center>
        <hr />
        <p className="lead mt-4 text-800 font-sans-serif fw-semi-bold">
          Votre habilitation ne vous permet pas d'accéder à cette ressource.
        </p>
        <Link className="btn btn-primary btn-sm mt-3" to="/">
          <FontAwesomeIcon icon={faHome} className="me-2" />
          Retour à l'accueil
        </Link>
      </Card.Body>
    </Card>
  );
};

export default Error401;
